<template>
  <a-modal v-model="visible" title="创建租约" :width="800" @cancel="close" :keyboard="false" :maskClosable="false">
    <a-descriptions :title="formData.houseName" :column="2">
      <a-descriptions-item label="房间类型">{{
        formData.rentTypeName
      }}</a-descriptions-item>
      <a-descriptions-item label="房间号">{{
        formData.no
      }}</a-descriptions-item>
      <a-descriptions-item label="付款周期">{{
        paramData.payCycle
      }}</a-descriptions-item>
      <a-descriptions-item label="付款方式">
        <a-select
          style="width: 150px"
          v-model="paramData.payWay"
          @change="handleChange"
        >
          <a-select-option
            v-for="item in payWayList"
            :value="item.dictCode"
            :key="item.dictCode"
            >{{ item.dictName }}</a-select-option
          >
        </a-select>
      </a-descriptions-item>
      <a-descriptions-item label="月租金"
        ><a-input v-model="paramData.monthRent" suffix="元"></a-input
      ></a-descriptions-item>
      <a-descriptions-item label="押金"
        ><a-input v-model="paramData.deposit" suffix="元"></a-input
      ></a-descriptions-item>
      <a-descriptions-item label="租约开始日期"
        ><a-date-picker
          @change="dateChange"
          :format="dateFormat"
          v-model="paramData.startTime"
      /></a-descriptions-item>
      <a-descriptions-item label="下次交租日期">{{
        paramData.nextTime
      }}</a-descriptions-item>
      <a-descriptions-item label="租约结束日期"
        ><a-date-picker :format="dateFormat" v-model="paramData.finishTime"
      /></a-descriptions-item>
    </a-descriptions>
    <a-descriptions title="租客信息"></a-descriptions>
    <a-form-model
      ref="ruleForm"
      :rules="userSimpleRule"
      :model="userSimpleData"
      :labelCol="{ span: 8 }"
      :wrapperCol="{ span: 16 }"
      class="form"
    >
      <a-row :gutter="24">
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="姓名" prop="realName"
            ><a-input placeholder="请输入姓名" v-model="userSimpleData.realName"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="出租方式" prop="sex">
            <a-radio-group v-model="userSimpleData.sex">
              <a-radio value="男">男</a-radio>
              <a-radio value="女">女</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="手机号" prop="mobile"
            ><a-input placeholder="请输入手机号" v-model="userSimpleData.mobile"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12" :xl="12">
          <a-form-model-item label="身份证号" prop="idcard"
            ><a-input
              placeholder="请输入身份证号"
              v-model="userSimpleData.idcard"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="24" :xl="24">
          <a-form-model-item
            label="补充条款"
            :labelCol="{ span: 4 }"
            :wrapperCol="{ span: 20 }"
          >
            <a-input
              style="width: 100%;"
              v-model="userSimpleData.terms"
              :rows="4"
              type="textarea"
              :maxLength="200"
              placeholder="请输入补充条款"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

    <div v-if="verifyParam.visible">
        <a-descriptions title="验证租客身份"></a-descriptions>
        <a-form-model
        ref="verifyForm"
        :rules="verifyParamRule"
        :model="verifyParam"
        :labelCol="{ span: 4 }"
        :wrapperCol="{ span: 20 }"
        class="form"
      >
        <a-row :gutter="24">
          <a-col :sm="24" :md="12" :xl="12">
            <a-form-model-item label="身份校验码" prop="vcode"
              ><a-input
                placeholder="填入租客手机接收的身份校验码"
                v-model="verifyParam.vcode"
            /></a-form-model-item>
          </a-col>
        </a-row>
        <a-row v-if="verifyParam.showAgreement">
          <a-col :sm="24" :md="24" :xl="24">
            <a-form-model-item
              label=""
              :labelCol="{ span: 2 }"
              :wrapperCol="{ span: 22 }"
            >
              <p class="tip-text">提示：需要租客打开以下链接，进行CA电子认证服务协议阅读，确认同意后，方能进行后续租房合同流转</p>
              <a-input
                style="width: 100%;"
                v-model="verifyParam.agreementUrl"
                :rows="4"
                type="textarea"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button type="primary" class="opt" v-if="!verifyParam.visible && !verifyParam.pass" :loading="verifyParam.checking" @click="createLeasePreCheck">获取租客身份校验码</a-button>
        <a-button type="primary" class="opt" v-if="verifyParam.visible && !verifyParam.pass" :loading="verifyParam.verifying" @click="submitVerify">验证租客身份</a-button>
      <a-popconfirm
        title="确认创建租约吗？"
        @confirm="ok"
        okText="确认"
        cancelText="取消"
        v-if="verifyParam.pass"
      >
        <a-button
          type="primary"
          :loading="confirmLoading"
          :disabled="cancelLoading"
          >确认</a-button
        >
      </a-popconfirm>
    </template>
    <div class="ps-form-style-desc">
      <h3>特别说明</h3>
      <p>1、确保租客信息填写正确。</p>
      <p>2、创建租约过程存在多个认证环节，请耐心等待。</p>
    </div>
  </a-modal>
</template>
<script>
import moment from "moment";
import cloneDeep from "lodash.clonedeep";
import {
  monthFormat,
  formatting,
  mobile,
  idcard
} from "../../../../utils/util.js";
export default {
  name: "CreateLeaseForm",
  data() {
    let handleMobile = (rule, value, callback) => {
      if (!mobile(value)) {
        callback("请输入正确的手机号");
      }
      callback();
    };
    let handleIdcard = (rule, value, callback) => {
      if (!idcard(value)) {
        callback("请输入正确的身份证号");
      }
      callback();
    };
    return {
      verifyParam: {
        checking: false,
        visible: false,
        verifying: false,
        pass: false,
        showAgreement: false,
        vcode: '',
        personalIdentity3Key: '',
        agreementUrl: '',
        userNo: ''
      },
      verifyParamRule: {
        vcode: [{ required: true, message: "请输入身份校验码" }]
      },
      dateFormat: "YYYY-MM-DD",
      visible: false,
      formData: {},
      paramData: {
        leaseNo: "",
        payCycle: "",
        monthRent: 0, //月租金
        deposit: 0, //押金
        payWay: "",
        payWayName: "",
        month: "",
        startTime: "",
        finishTime: "",
        nextTime: ""
      },
      userInfo: {},
      payWayList: [], //付款方式
      confirmLoading: false, //确认
      cancelLoading: false, //取消
      userSimpleData: {
        realName: "",
        sex: "男",
        mobile: "",
        idcard: "",
        terms: ""
      },
      userSimpleRule: {
        realName: [{ required: true, message: "请输入姓名" }],
        sex: [{ required: true, message: "请选择性别" }],
        mobile: [
          { required: true, message: "请输入手机号" },
          { validator: handleMobile, trigger: "change" }
        ],
        idcard: [
          { required: true, message: "请输入身份证号" },
          { validator: handleIdcard, trigger: "change" }
        ]
      },
    };
  },
  methods: {
    show(data) {
      this.userInfo = this.$store.getters.userInfo;
      this.visible = true;
      this.formData = data;
      this.paramData.startTime = moment(
        this.formData.startTime.substring(0, 10),
        this.dateFormat
      );
      this.paramData.finishTime = moment(
        this.formData.finishTime.substring(0, 10),
        this.dateFormat
      );
      this.computeNextTime(this.paramData.startTime.toDate());
      // this.paramData.nextTime = this.formData.nextTime;
      this.paramData.month = this.formData.month;
      this.paramData.monthRent = this.formData.monthRent;
      this.paramData.deposit = this.formData.deposit;
      this.paramData.payCycle = monthFormat(this.formData.month);
      this.paramData.payWay = this.formData.payWay;
      if(data.personalInfo){
        this.userSimpleData = Object.assign({}, data.personalInfo);
      }
      this.getBaseInfo();
    },
    createLeasePreCheck(){
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = {};
          param.userSimple = this.userSimpleData;
          let houseUserLease = Object.assign({}, this.paramData);
          houseUserLease.houseNo = this.formData.houseNo;
          houseUserLease.rentType = this.formData.rentType;
          houseUserLease.rentTypeName = this.formData.rentTypeName;
          houseUserLease.houseName = this.formData.houseName;
          houseUserLease.houseNo = this.formData.houseNo;
          houseUserLease.no = this.formData.no;
          houseUserLease.address = this.formData.address;
          houseUserLease.sta = "R";
          houseUserLease.terms = this.userSimpleData.terms;
          houseUserLease.keeperUserNo = this.formData.keeperUserNo;
          houseUserLease.merchantNo = this.formData.merchantNo;
          let start = this.paramData.startTime.format(this.dateFormat);
          let end = this.paramData.finishTime.format(this.dateFormat);
          houseUserLease.startTime = start + " 00:00:00";
          houseUserLease.finishTime = end + " 23:59:59";
          houseUserLease.nextTime = this.paramData.nextTime + " 23:59:59";
          houseUserLease.checkSta = this.userInfo.userType == "2" ? "C" : "S";
          houseUserLease.businessType = "sure";
          delete houseUserLease.payCycle;
          delete param.userSimple.terms;
          param.houseUserLease = houseUserLease;
          param.type = "copy";
          if (!this.verifyParam.checking) {
            this.verifyParam.checking = true;
          }
          this.$http.roomBksApi.merchantCreateLeasePreCheck(param).then(res => {
            this.verifyParam.checking = false;
            if (res.result == 0) {
              if(res.resultObject.code == 100){
                this.verifyParam.visible = true;
                this.verifyParam.agreementUrl = res.resultObject.ssqAgreementUrl;
                this.verifyParam.personalIdentity3Key = res.resultObject.personalIdentity3Key;
                this.verifyParam.userNo = res.resultObject.userNo;
              } else {
                this.verifyParam.visible = false;
                this.verifyParam.pass = true;
              }
            }
          });
        }
      });
    },
    submitVerify(){
      this.verifyParam.showAgreement = false;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let {vcode, personalIdentity3Key, userNo, authType} = this.verifyParam;
          let param = {vcode, personalIdentity3Key, userNo};
          param.authType = "mobile";
          param.userType = "personal";
          if (!this.verifyParam.verifying) {
            this.verifyParam.verifying = true;
          }
          this.$http.roomBksApi.personalAuthVcodeVerify(param).then(res => {
            this.verifyParam.verifying = false;
            if(res.result == 0){
              this.verifyParam.pass = true;
              this.verifyParam.showAgreement = true;
            }
          });
        }
      });
    },
    ok() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = {};
          param.userSimple = this.userSimpleData;
          let houseUserLease = Object.assign({}, this.paramData);
          houseUserLease.houseNo = this.formData.houseNo;
          houseUserLease.rentType = this.formData.rentType;
          houseUserLease.rentTypeName = this.formData.rentTypeName;
          houseUserLease.houseName = this.formData.houseName;
          houseUserLease.houseNo = this.formData.houseNo;
          houseUserLease.no = this.formData.no;
          houseUserLease.address = this.formData.address;
          houseUserLease.sta = "R";
          houseUserLease.terms = this.userSimpleData.terms;
          houseUserLease.keeperUserNo = this.formData.keeperUserNo;
          houseUserLease.merchantNo = this.formData.merchantNo;
          let start = this.paramData.startTime.format(this.dateFormat);
          let end = this.paramData.finishTime.format(this.dateFormat);
          houseUserLease.startTime = start + " 00:00:00";
          houseUserLease.finishTime = end + " 23:59:59";
          houseUserLease.nextTime = this.paramData.nextTime + " 23:59:59";
          houseUserLease.checkSta = this.userInfo.userType == "2" ? "C" : "S";
          houseUserLease.businessType = "sure";
          delete houseUserLease.payCycle;
          delete param.userSimple.terms;
          param.houseUserLease = houseUserLease;
          param.type = "copy";
          if (!this.confirmLoading) {
            this.confirmLoading = true;
          }
          this.$http.roomBksApi.merchantCreateLease(param).then(res => {
            this.confirmLoading = false;
            if (res.result == 0) {
              this.$message.success(res.msg);
              this.close();
              this.$emit("success");
            }
          });
        }
      });
    },
    close() {
      this.visible = false;
      this.confirmLoading = false;
      this.cancelLoading = false;
    },
    cancel() {
      this.close();
    },
    async getBaseInfo() {
      this.$http.roomBksApi.findHouseKindData().then(res => {
        if (res.result == 0) {
          this.payWayList = res.resultObject.payWayList;
          this.getPayWay(this.paramData.payWay);
        }
      });
    },

    dateChange(value) {
      this.computeNextTime(value.toDate());
    },
    computeNextTime(value) {
      if (value) {
        let m = 0;
        if (this.paramData.month == 1) {
          m = 1;
        } else {
          m = this.paramData.month - 1;
        }
        value.setMonth(value.getMonth() + parseInt(m));
        this.paramData.nextTime = formatting(value);
      }
    },
    handleChange(selectItem) {
      let args = this.getPayWay(selectItem);
      let arr = args.split(",");
      if (arr && arr.length > 1) {
        let month = arr[1];
        this.paramData.month = month;
        let multiple = arr[0];
        this.paramData.deposit =
          parseInt(multiple) * parseInt(this.paramData.monthRent);
        this.paramData.payCycle = monthFormat(month);
        this.computeNextTime(this.paramData.startTime.toDate());
      }
    },
    getPayWay(value) {
      let args = "";
      for (let item of this.payWayList) {
        if (item.dictCode == value) {
          this.paramData.payWayName = item.dictName;
          args = item.args;
          break;
        }
      }
      return args;
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-descriptions-item-label {
  min-width: 75px;
  text-align: right;
}
.ps-form-style-desc {
  h3 {
    margin: 0 0 12px;
    font-size: 16px;
    line-height: 32px;
    color: red;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    line-height: 22px;
    color: red;
  }
}
</style>
